import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param entityId
 */
class QualityCheckServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createQualityCheck = async (payload) => {
    const qc = await Helpers.post({
      url: Constants.QUALITY_CHECK,
      data: payload,
    });
    return qc;
  };

  /**
 *
 * @param {*} payload
 * @return
 */
  updateQualityCheck = async (payload) => {
    const qc = await Helpers.put({
      url: Constants.QUALITY_CHECK,
      data: payload,
    });
    return qc;
  };

  /**
 *
 * @param {*} payload
 * @return
 */
  deleteQualityCheck = async (payload) => {
    const qc = await Helpers.delete({
      url: Constants.QUALITY_CHECK,
      data: payload,
    });
    return qc;
  };

  /**
 * @param tenantId
 * @param entityId
 * @param entityName
 * @param status
 * @param qcType
 * @param page
 * @param limit
 * @param searchKeyword
 * @return
 */
  getQualityChecks = async (tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId,qcCheckId, isListScreen) => {
    let url = `${Constants.QUALITY_CHECK}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (entityId) url += `entity_id=${entityId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (status) url += `status=${status}&`;
    if (qcType) url += `type_of_qc=${qcType}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (batchId) url += `batch_id=${batchId}&`;
    if (qcCheckId) url += `quality_check_id=${qcCheckId}&`;
    if (defaultAssigneeId) url += `default_assignee_ids=${defaultAssigneeId}&`;
    if (isListScreen) url += `is_list_screen=${isListScreen}&`;

    const qcs = await Helpers.get({ url });
    return qcs;
  };

  /**
     * @param {*} tenantId
     * @param {*} qualityCheckId
     * @return
     */
  getDownloadQualityChecks = async (tenantId, qualityCheckId, entityName, entityId, userId) => {
    let url = `${Constants.QUALITY_CHECK}/download?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (qualityCheckId) url += `quality_check_id=${qualityCheckId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (entityId) url += `entity_id=${entityId}&`;
    if (userId) url += `user_id=${userId}&`;
    const qc = await Helpers.getFile({
      url,
    });
    return qc;
  };

  // Get quality check Report

  getQualityCheckReport = async (tenantId, entityName, status, startDate, endDate, selectedEmails, operationType, userId) => {
    let url = `${Constants.QUALITY_CHECK_REPORT}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (status) url += `status=${status}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (selectedEmails) url += `emails=${selectedEmails}&`;
    if (operationType) url += `type=${operationType}&`;
    if (userId) url += `user_id=${userId}&`;
    const QCReport = await Helpers.get({ url });
    return QCReport;
  };

  // Qc retest
  retestQualityCheck = async (payload) => {
    const qc = await Helpers.post({
      url: Constants.QC_RETEST,
      data: payload,
    });
    return qc;
  };

  // Qc on Hold
  putQualityCheckOnHold = async (payload) => {
    const qc = await Helpers.put({
      url: Constants.QC_ON_HOLD,
      data: payload,
    });
    return qc;
  };

  updateQualityCheckAssignees = async (payload) => {
    const qc = await Helpers.put({
      url: `${Constants.QUALITY_CHECK}/update_qc_assignee`,
      data: payload,
    });
    return qc;
  };
}

export default new QualityCheckServices();
